export default __webpack_public_path__ + "static/media/decor2.65cdd562.webp";